import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { type LocaleCodeValues } from '~/locales'

export const useLanguageTextWidth = (values: {
  [K in LocaleCodeValues]: number
}) => {
  const { i18n } = useTranslation()
  const currentLanguage = i18n.language

  return useMemo(
    () => values[currentLanguage as LocaleCodeValues],
    // eslint-disable-next-line react-hooks/exhaustive-deps -- 参照を見ると意図通りにメモ化できないので値を直接見る
    [currentLanguage, ...Object.values(values)],
  )
}
